import { useState, useEffect } from 'react';
import { useUpdateEffect } from './useUpdateEffect';
import automobyApi from '../Api';
 
export const useSalary = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/salary/list", filter)
      setItems(response.data.salaries);
      setTotal(response.data.total);
      return response.data.salaries
    } catch (error) { 
      console.error("error:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/salary/all", requestData)
      setItems(response.data.salaries);
      setTotal(response.data.total);
      return response.data.salaries
    } catch (error) {

      console.error("error:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/salary/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (salary, count) => {
    try {
      const requestData = {
        salary: salary,
        count: count,
      };

      const response = await automobyApi.post("/salary/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/salary/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          salary_id: id
        };
        const response = await automobyApi.post(`/salary/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const updateLocal = async (salary) => {
    setItems(items.map(item =>
      item.id === salary.id ? salary : item
    ));
  }
 

  const salaryService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { salaryService };
}